/**
 * ModalTratamientoDuplicado.js
 * Modal que se muestra cuando se intenta crear un tratamiento
 * y ya existe uno activo para la mascota.
 * Ofrece opciones: ver actual, reemplazar, o cancelar.
 */
import React from 'react';

export default function ModalTratamientoDuplicado({
  show,
  onClose,
  tratamientoExistenteId,
  onVerActual,
  onReemplazar,
  reemplazando = false
}) {
  if (!show) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 100002,
        padding: '16px'
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: '20px',
          maxWidth: '420px',
          width: '100%',
          overflow: 'hidden',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{
            padding: '24px 24px 16px',
            textAlign: 'center',
            borderBottom: '1px solid #e5e7eb'
          }}
        >
          <div style={{ fontSize: '48px', marginBottom: '12px' }}>
            <span role="img" aria-label="warning">⚠️</span>
          </div>
          <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#111' }}>
            Ya existe un tratamiento activo
          </h3>
          <p style={{ margin: '12px 0 0', color: '#666', fontSize: '14px', lineHeight: 1.5 }}>
            Esta mascota ya tiene un tratamiento en curso.
            <br />
            ¿Qué deseas hacer?
          </p>
        </div>

        {/* Opciones */}
        <div style={{ padding: '20px' }}>
          {/* Opción 1: Ver tratamiento actual */}
          <button
            onClick={() => onVerActual(tratamientoExistenteId)}
            disabled={reemplazando}
            style={{
              width: '100%',
              padding: '16px',
              marginBottom: '12px',
              border: '2px solid #4CAF50',
              borderRadius: '12px',
              backgroundColor: '#fff',
              cursor: reemplazando ? 'not-allowed' : 'pointer',
              textAlign: 'left',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              transition: 'all 0.2s'
            }}
          >
            <span style={{ fontSize: '24px' }}>🔥</span>
            <div>
              <div style={{ fontWeight: '600', color: '#2E7D32', fontSize: '15px' }}>
                Ver tratamiento actual
              </div>
              <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>
                Continuar con el tratamiento en progreso
              </div>
            </div>
          </button>

          {/* Opción 2: Reemplazar */}
          <button
            onClick={onReemplazar}
            disabled={reemplazando}
            style={{
              width: '100%',
              padding: '16px',
              marginBottom: '12px',
              border: '2px solid #FF5722',
              borderRadius: '12px',
              backgroundColor: reemplazando ? '#FBE9E7' : '#fff',
              cursor: reemplazando ? 'not-allowed' : 'pointer',
              textAlign: 'left',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              transition: 'all 0.2s'
            }}
          >
            <span style={{ fontSize: '24px' }}>
              {reemplazando ? '⏳' : '🔄'}
            </span>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: '600', color: '#E64A19', fontSize: '15px' }}>
                {reemplazando ? 'Reemplazando...' : 'Cancelar anterior y crear nuevo'}
              </div>
              <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>
                Se perderá el progreso del tratamiento actual
              </div>
            </div>
            {reemplazando && (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                style={{ color: '#FF5722' }}
              />
            )}
          </button>

          {/* Opción 3: Cancelar */}
          <button
            onClick={onClose}
            disabled={reemplazando}
            style={{
              width: '100%',
              padding: '14px',
              border: '1px solid #e5e7eb',
              borderRadius: '12px',
              backgroundColor: '#f9fafb',
              cursor: reemplazando ? 'not-allowed' : 'pointer',
              fontSize: '14px',
              color: '#666',
              fontWeight: '500'
            }}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}
